import { FILTER_MESSAGES, FiltersMessages } from "../inputs/filters.messages";

export type ImportationsFiltersMessages = FiltersMessages & {
  dateOption: string;
  typeOption: string;
  fileNameOption: string;
  statusOption: string;
  successOption: string;
  errorOption: string;
  allOption: string;
  contactOption: string;
  productOption: string;
  pendingOption: string;
  processingOption: string;
  completedOption: string;
  selectTypePlaceholder: string;
  selectStatusPlaceholder: string;
};

export const IMPORTATIONS_FILTER_MESSAGES: ImportationsFiltersMessages = {
  ...FILTER_MESSAGES,
  dateOption: "Data",
  typeOption: "Tipo",
  fileNameOption: "Arquivo",
  statusOption: "Status",
  successOption: "Sucesso",
  errorOption: "Erro",
  allOption: "Todos",
  contactOption: "Contato",
  productOption: "Produto",
  pendingOption: "Pendente",
  processingOption: "Processando",
  completedOption: "Concluído",
  selectTypePlaceholder: "Selecionar tipo",
  selectStatusPlaceholder: "Selecionar status",
};

export default IMPORTATIONS_FILTER_MESSAGES;